import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #4CC5B6;
  border-radius: 10px;
  display: flex;
  gap: 10px;
  justify-content: left;
  padding: 16px;
  width: 100%;
`

export const Label = styled.label`
  font-family: Source Sans 3;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: nowrap;
`

export const Input = styled.input`
  flex: 0;

  &:focus {
    outline: 0 none;
  }
`
